import React, { useRef, useState, useEffect } from 'react';

import { TextField, InputAdornment, Slider } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { StyledFilterDisplay, LastMenuItem, AbsoluteContainer } from '../styles';

const sliderConfig = {
  minValue: 0,
  maxValue: 100000000,
  step: 10000,
};

const SliderFilter = ({ selectedFilters, updateFilters, filterName, noLeftBorder = false, icon, index }) => {
  const [selected, setSelected] = useState([null, null]);
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const makeCurrentStateEqualToSelectedState = () => {
    setSelected(selectedFilters.length ? selectedFilters : [null, null]);
  };

  const onMinAmountChange = (e) => {
    setSelected([e.target.value, selected[1]]);
  };

  const onMaxAmountChange = (e) => {
    setSelected([selected[0], e.target.value]);
  };

  const handleRangeChange = (event, newValue) => {
    setSelected(newValue);
  };

  const handleApplyClick = () => {
    updateFilters(selected, filterName);
    setIsVisible(false);
  };

  const handleOpenClick = (e) => {
    e.stopPropagation();
    setIsVisible(!isVisible);
    makeCurrentStateEqualToSelectedState();
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  const removeFilters = (e) => {
    e.stopPropagation();
    updateFilters([], filterName);
  };

  return (
    <Container>
      <StyledFilterDisplay
        width="20%"
        icon={icon}
        name={filterName}
        selectedCount={selectedFilters.filter((f) => f).length}
        noLeftBorder={noLeftBorder}
        active={selectedFilters.filter((f) => f).length > 0}
        onClick={handleOpenClick}
        removeFilters={removeFilters}
        ref={buttonRef}
      />
      {isVisible && (
        <AbsoluteContainer ref={wrapperRef} middle={(index + 2) % 3 === 0} right={(index + 1) % 3 === 0}>
          <DropdownList>
            <StyledTypography variant="body" color="#666" leftGutter={2}>
              Select amount
            </StyledTypography>
            <StyledSlider
              value={selected}
              onChange={handleRangeChange}
              min={sliderConfig.minValue}
              max={sliderConfig.maxValue}
              step={sliderConfig.step}
              valueLabelDisplay="off"
              aria-labelledby="range-slider"
            />
            <StyledTextField
              type="number"
              variant="outlined"
              value={selected[0] || ''}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <StyledTypography>₹</StyledTypography>
                  </InputAdornment>
                ),
              }}
              placeholder="Min"
              onChange={onMinAmountChange}
            />
            to
            <StyledTextField
              type="number"
              variant="outlined"
              value={selected[1] || ''}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <StyledTypography>₹</StyledTypography>
                  </InputAdornment>
                ),
              }}
              placeholder="Max"
              onChange={onMaxAmountChange}
            />
            <LastMenuItem onClick={handleApplyClick}>
              <StyledTypography color="primary" variant="body2">
                Apply
              </StyledTypography>
            </LastMenuItem>
          </DropdownList>
        </AbsoluteContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: inline;
`;

const StyledTextField = styled(TextField)`
  margin: 1rem;
  width: 135px;
  vertical-align: sub;
  input {
    padding: 10px 10px 10px 3px;
    font-size: 0.875rem;
  }
`;

const StyledSlider = styled(Slider)`
  margin: 1rem 1rem 0 1.5rem;
  width: calc(100% - 2.5rem);
`;

const DropdownList = styled.ul`
  background: white;
  width: 355px;
  padding: 1rem 0 0 0;
  margin: 0;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  li {
    margin-bottom: 0px;
  }
`;

export default SliderFilter;
